export function isNotFoundError(error) {
  const message = String(
    error?.response?.data?.error_msg ||
      error?.response?.data?.message ||
      error?.message ||
      ''
  ).toLowerCase();

  if (error?.response?.status === 404) {
    return true;
  }

  return (
    message.includes('not found') ||
    message.includes('deleted') ||
    message.includes('no longer have access') ||
    message.includes('not available') ||
    message.includes('no longer')
  );
}
